module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_10.36c715bb.jpg";